const doc = [({"en":({"js":({"merfoto":({"photo_session_groups":({"card":({"photo_card":({"download":"Download", "buy":"Buy"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;